import httpClient from './httpClient'

export default {
  async getCep(cepNumber) {
    let ret = await httpClient.get(`area/cep?cep=${cepNumber}`)
    return ret
  },
  async getCountries() {
    let ret = await httpClient.get('area/countries')
    return ret
  },
  async getStates() {
    let ret = await httpClient.get('area/states')
    return ret
  },
  async getStateCities(stateNumber) {
    let ret = await httpClient.get(`area/cities?state=${stateNumber}`)
    return ret
  },
}
